import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

import { DashboardInnerPage } from "./dashboard.inner.page";

export const DashboardPageWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "dashboard-page-wrapper",
})``;

export const DashboardInner = (): JSX.Element => {
  return (
    <DashboardPageWrapper>
      <DashboardInnerPage />
    </DashboardPageWrapper>
  );
};
